import { Container, Divider, Grid, Segment } from "semantic-ui-react";
import IkonInvesteringsunivers from "../images/IkonInvesteringsunivers.svg";
import IkonForvaltning from "../images/IkonForvaltning.svg";
import IkonRisikostyring from "../images/IkonRisikostyring.svg";
import IkonSamfundsansvar from "../images/IkonSamfundsansvar.svg";
import "./Selvstaendige.css";

const PfaPlus = (props) => (
  <div style={{ backgroundColor: "white" }}>
    <Container text>
      <Segment basic>
        <p>1. oktober 2026</p>
        <h2 className="trompet">INVESTERINGSFOKUS</h2>
        <h2 className="ui header" style={{ paddingTop: 0 }}>
          PFA Plus
        </h2>
      </Segment>
    </Container>

    <Container text>
      <Segment basic>
        <p className="manchet">
          Med PFA Plus bliver din opsparing investeret med udgangspunkt i hele
          PFA’s investeringsunivers. Det betyder, at din opsparing bliver
          investeret i aktier, obligationer, ejendomme, private equity,
          infrastruktur og skov.
        </p>

        <p>
          PFA’s investeringseksperter tilpasser løbende dine investeringer efter
          verdenssituationen. Samtidig benytter PFA’s investeringseksperter
          forskellige redskaber til at mindske risici og beskytte din opsparing
          mod store udsving i markedet.
        </p>

        <h3>PFA Plus er til dig, der ønsker, at:</h3>
        <ul>
          <li>
            din opsparing investeres i et bredt investeringsunivers med mulighed
            for at investere i mange forskellige aktivklasser inklusive
            alternative investeringer i form af ejendomme, unoterede aktier,
            sikkerhed og grøn omstilling.
          </li>
          <li>
            eksperter overvåger og justerer løbende investeringen af din
            opsparing til verdenssituationen.
          </li>
        </ul>

        <h3>Fordele ved PFA Plus</h3>
        <Divider hidden />

        <Grid centered stackable columns={2}>
          <Grid.Row>
            <Grid.Column width={3}>
              <div
                className="fordele-ikon"
                style={{ backgroundImage: `url(${IkonInvesteringsunivers})` }}
              ></div>
            </Grid.Column>
            <Grid.Column width={13}>
              <p>
                <b>Bredt investeringsunivers:</b> Med PFA Plus investeres din
                opsparing i mange forskellige typer af aktiver – fra aktier og
                obligationer til ejendomme, private equity og infrastruktur. Det
                giver både spredning af risiko og mulighed for et højere afkast.
              </p>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width={3}>
              <div
                className="fordele-ikon"
                style={{ backgroundImage: `url(${IkonForvaltning})` }}
              ></div>
            </Grid.Column>
            <Grid.Column width={13}>
              <p>
                <b>Aktiv forvaltning,</b> hvor vi tror på, at vi kan skabe
                værdi. Dette er bl.a. danske aktier og obligationer fordi
                markedskendskab og nærhed gør en forskel.
              </p>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width={3}>
              <div
                className="fordele-ikon"
                style={{ backgroundImage: `url(${IkonRisikostyring})` }}
              ></div>
            </Grid.Column>
            <Grid.Column width={13}>
              <p>
                <b>Risikostyring</b> gør, at PFA’s investeringseksperter løbende
                kan tilpasse investeringerne til den aktuelle verdenssituation
                f.eks. ved at sikre beskyttelse, når der er store stød i
                økonomien.
              </p>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width={3}>
              <div
                className="fordele-ikon"
                style={{ backgroundImage: `url(${IkonSamfundsansvar})` }}
              ></div>
            </Grid.Column>
            <Grid.Column width={13}>
              <p>
                <b>Ekstra fokus på samfundsansvar:</b> Det betyder, at PFA har
                mulighed for at investere i fx start-ups, sikkerhed og grøn
                omstilling.
              </p>
            </Grid.Column>
          </Grid.Row>
        </Grid>

        <Divider hidden />
        <h3>PFA Plus og ansvarlige investeringer </h3>
        <p>
          Investeringerne i PFA Plus er underlagt PFA’s politik for ansvarlige
          investeringer og aktivt ejerskab. Det betyder, at der stilles krav til
          selskabernes arbejde med sociale-, miljø- og ledelsesmæssige
          forhold.{" "}
        </p>
      </Segment>
    </Container>
  </div>
);

export default PfaPlus;
